import { USER } from "../constants";
import { instance, baseUrl } from "../../axios";

let getUsersAction = (companyId) => {
  return (dispatch) => {
    dispatch({
      type: USER.GET_USERS,
    });
    instance
      .get("/user?company_id=" + companyId)
      .then((results) => {
        dispatch({
          type: USER.GET_USERS_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: USER.GET_USERS_FAILURE,
          payload: error,
        });
      });
  };
};

let updateUserAction = (user) => {
  return (dispatch) => {
    dispatch({
      type: USER.UPDATE_USER,
    });
    instance
      .post("/user/" + user.id, user)
      .then((results) => {
        dispatch({
          type: USER.UPDATE_USER_SUCCESS,
          payload: results.data,
        });
        dispatch(getUsersAction(results.data.company_id));
      })
      .catch((error) => {
        dispatch({
          type: USER.UPDATE_USER_FAILURE,
          payload: error,
        });
      });
  };
};

let resetUserPasswordAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: USER.RESET_PASSWORD,
    });
    instance({
      method: "POST",
      url: baseUrl + "/user/reset",
      data: body,
    })
      .then((results) => {
        dispatch({
          type: USER.RESET_PASSWORD_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: USER.RESET_PASSWORD_FAILURE,
          payload: error,
        });
      });
  };
};

let definePasswordAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: USER.DEFINE_PASSWORD,
    });
    instance({
      method: "POST",
      url: baseUrl + "/user/define",
      data: body,
    })
      .then((results) => {
        dispatch({
          type: USER.DEFINE_PASSWORD_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: USER.DEFINE_PASSWORD_FAILURE,
          payload: error,
        });
      });
  };
};

let getAllUsersAction = () => {
  return (dispatch) => {
    dispatch({ type: USER.GET_ALL_USERS });
    instance
      .get("/user")
      .then((results) => {
        dispatch({ type: USER.GET_ALL_USERS_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        dispatch({ type: USER.GET_ALL_USERS_FAILURE, payload: error });
      });
  };
};

let createUserAction = (body) => {
  return (dispatch) => {
    dispatch({ type: USER.CREATE_USER });
    instance
      .post("/user", body)
      .then((results) => {
        dispatch({ type: USER.CREATE_USER_SUCCESS, payload: results.data });
        dispatch(getAllUsersAction());
      })
      .catch((error) => {
        dispatch({ type: USER.CREATE_USER_FAILURE, payload: error });
      });
  };
};

let deleteUserAction = (id) => {
  return (dispatch) => {
    dispatch({ type: USER.DELETE_USER });
    instance
      .delete("/user/" + id)
      .then(() => {
        dispatch({ type: USER.DELETE_USER_SUCCESS, payload: id });
      })
      .catch((error) => {
        dispatch({ type: USER.DELETE_USER_FAILURE, payload: error });
      });
  };
};

let setUserAction = (user) => {
  return (dispatch) => {
    dispatch({
      type: USER.SET_USER,
      payload: user,
    });
  };
};

let cleanUserAction = () => {
  return (dispatch) => {
    dispatch({
      type: USER.CLEAN_USER,
    });
  };
};

let cleanErrorAction = () => {
  return (dispatch) => {
    dispatch({
      type: USER.CLEAN_ERROR,
    });
  };
};

let resetUserAction = () => {
  return (dispatch) => {
    dispatch({
      type: USER.RESET,
    });
  };
};

export {
  setUserAction,
  cleanUserAction,
  getUsersAction,
  getAllUsersAction,
  createUserAction,
  deleteUserAction,
  updateUserAction,
  resetUserAction,
  definePasswordAction,
  cleanErrorAction,
  resetUserPasswordAction,
};
